import styled from 'styled-components';

export const ProjectRelatedArticleWrapper = styled.div`
  margin-top: 8px;
`;

export const SectionTitle = styled.p`
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 500;
  color: #333f48;
  line-height: 28px;
`;

export const ProjectRelatedArticleDetail = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid #d2d6da;
  transition: all 0.4;
  &:last-child {
    border: none;
  }
  &:hover {
    .article-image {
      img {
        opacity: 0.8;
      }
    }
    .article-title {
      color: #697684;
    }
  }
`;

export const DetailWrapper = styled.div`
  display: flex;
`;

export const ArticleImage = styled.div`
  width: 168px;
  height: 96px;
  flex-shrink: 0;
  background-color: #000000;
  position: relative;
  .lazy-image-wrapper {
    height: 100%;
    width: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .no-image {
    width: 100%;
    height: 100%;
  }
  .img-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .play-icon-wrapper {
    width: 40px;
    height: 40px;
    font-size: 10px;
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 10;
    top: 50%;
    left: 50%;
  }
`;

export const ArticleInfo = styled.div`
  margin-left: 16px;
  .article-post-type {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 300;
    color: #697684;
    line-height: 14px;
  }
  .article-title {
    display: -webkit-box;
    margin: 0;
    max-height: 52px;
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    color: #333f48;
    word-break: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
